/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeries1/view.blocks to change it.
import AllImageSeries from './AllImageSeries/index'
import ImageSeries from './ImageSeries/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageSeries1({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/Breadcrumb/ImageSeries"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ImageSeries.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AllImageSeries
  viewPath={`${viewPath}/AllImageSeries`}
/>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
</div>
{children}
</React.Fragment>)
}